import {UIModeSelectorDetailsController, MatchmakingEntryCallback} from '../../../../shared/scripts/ui_html/home_page/UIModeSelectorDetailsController'

export class UIWModeSelectorDetailsController extends UIModeSelectorDetailsController {
    private readonly modeSelectorContainer: HTMLDivElement

    constructor(onEnterMatchmaking: MatchmakingEntryCallback) {
        super(onEnterMatchmaking)
        this.modeSelectorContainer = document.getElementById('mm-mode-selector-container') as HTMLDivElement
    }

    protected onShow() {
        this.modeSelectorContainer.classList.add('hidden')
    }

    protected onHide() {
        this.modeSelectorContainer.classList.remove('hidden')
    }
}

